module.exports = __webpack_public_path__ + "img/banner_itemtwo_bigimg.9b7ec8b2.png";